import useMediaQuery from "@/Hooks/useMediaQuery";
import Column from "../Grid/Column";
import Container from "../Grid/Container";
import Row from "../Grid/Row";
import { Icon } from "@iconify/react/dist/iconify.js";

const IconsWithTextsEstateB = () => {
    const isMobile = useMediaQuery();

    const iconsData = [
        {
            img: `hugeicons:city-01`,
            text: <p>Lokalizacja w sercu <br /> dzielnicy o znakomitej <br /> infrastrukturze</p>
        },
        {
            img: 'hugeicons:green-house',
            text: <p>Bliskość terenów <br /> zielonych</p>
        },
        {
            img: 'hugeicons:floor-plan',
            text: <p>Funkcjonalne układy <br /> mieszkań</p>
        },
        {
            img: 'hugeicons:plant-01',
            text: <p>Mieszkania z balkonami, <br /> loggiami, ogródkami</p>
        },
        {
            img: 'hugeicons:car-parking-01',
            text: <p>Podziemna hala <br /> garażowa</p>
        },
        {
            img: 'hugeicons:bicycle-01',
            text: <p>Komórki lokatorskie, <br /> wózkarnia, rowerownia</p>
        },
        {
            img: 'hugeicons:yoga-02',
            text: <p>Atrakcyjne przestrzenie <br /> wspólne: zielony teren <br /> rekreacyjny, Balance <br /> Room w budynku</p>
        },
        {
            img: 'hugeicons:eco-energy',
            text: <p>Certyfikat BREEAM</p>
        },
    ]
    if (isMobile) {
        return (
            <section className="pt-14 mb-14 overflow-x-scroll">
                <Container>
                    <Row>
                        <Column className="flex !px-0 relative">
                            <div className="inline-flex overflow-x-scroll gap-x-4 max-w-[280px] mr-auto">
                                {iconsData.slice(0, 4).map((icon, i) => (
                                    <div key={i} className="min-w-[250px]">
                                        <Icon icon={icon.img}/>
                                        <div className="text-primary text-p leading-p text-center mt-6 font-extrabold uppercase">
                                            {icon.text}
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <Icon icon={`oui:arrow-right`} width={32} className="text-primary absolute right-4 top-[20%] z-10"/>
                        </Column>
                        <Column className="flex !px-0 relative">
                            <div className="inline-flex overflow-x-scroll gap-x-4 max-w-[280px] ml-auto">
                                {iconsData.slice(4, iconsData.length).map((icon, i) => (
                                    <div key={i} className="min-w-[250px]">
                                       <Icon icon={icon.img} width={112} className="text-primary mx-auto"/>
                                        <div className="text-primary text-p leading-p text-center mt-6 font-extrabold uppercase">
                                            {icon.text}
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <Icon icon={`oui:arrow-right`} width={32} className="text-primary absolute left-4 top-[20%] z-10"/>
                        </Column>
                    </Row>
                </Container>
            </section>
        )
    }

    return (
        <section className="py-18 mb-26">
            <Container>
                <Row className="gap-y-16 justify-center">
                    {iconsData.map((icon, i) => (
                        <Column xl={3} lg={3} md={4} key={i}>
                            <div>
                                <Icon icon={icon.img} width={112} className="text-primary mx-auto"/>
                                <div className="text-primary text-p leading-p text-center mt-6 font-extrabold uppercase">
                                    {icon.text}
                                </div>
                            </div>
                        </Column>
                    ))}
                </Row>
            </Container>
        </section>
    )
}

export default IconsWithTextsEstateB;